module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part One: The Burning Platform")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#sec1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Moment I Realized I Needed to Make a Change")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("1")]), _vm._v(" The Enron and Arthur Andersen Explosion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap02"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("2")]), _vm._v(" Twists and Turns during the Andersen Fire Sale")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Two: Finding My Purpose and Your Purpose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("3")]), _vm._v(" Step One: Write Your Life Purpose Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What You Want to Be About")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("4")]), _vm._v(" Step Two: Define Success in Your Key Roles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Determine to Be Present")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("5")]), _vm._v(" Step Three: Find a Job That Fits Your Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Consider Your Gifts, Your Experiences, and Your Passion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("6")]), _vm._v(" Step Four: Be Aware of God’s Guidance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("His Direction Can Come in Unexpected Ways")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("7")]), _vm._v(" Step Five: Analyze Where You Are")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Recalculate Your Priorities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("8")]), _vm._v(" Step Six: Find a Trainer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As You Look to the Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("9")]), _vm._v(" Step Seven: Recalibrate Your Lifestyle")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Recognize Overlooked Areas that Need to Be Addressed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("10")]), _vm._v(" Step Eight: Look Forward to Your Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Be Willing to Take a Risk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("11")]), _vm._v(" Step Nine: Determine to Do What’s Right")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Use Your Life Experiences to Plan Ahead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("12")]), _vm._v(" Step Ten: Keep Your Options Open")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Network with People You Trust")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("13")]), _vm._v(" Step Eleven: Take an Annual Review Each Year")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Suggested Annual Review Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part Three: My Next Chapter and Your Next Chapter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("14")]), _vm._v(" From Point A to Point B")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Change in Direction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("15")]), _vm._v(" A Long-Range Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The View from Years Ago to the Present")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword   A New Beginning?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "tocm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0